export default "__VITE_ASSET__DRa7X_zc__"